const outfitClickEventName = 'clickToWearOutfit';
const outfitWearEventName = 'wearOutfit';
const outfitEventType = 'webAvatarEditor';

export { outfitClickEventName, outfitWearEventName, outfitEventType };
